import React__default from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(
  {
    container: {
      padding: 0,
      listStyle: "none"
    },
    item: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: "400px",
      margin: 0,
      padding: 0
    }
  },
  { name: "BackstageSignInPage" }
);
const GridItem = ({ children }) => {
  const classes = useStyles();
  return /* @__PURE__ */ React__default.createElement(Grid, { component: "li", item: true, classes }, children);
};

export { GridItem, useStyles };
//# sourceMappingURL=styles.esm.js.map
